import React from "react";

function LegalSection() {
  return (
    <section className="legal-section" id="legal" aria-label="Informacion ligjor">
      <div className="container legal-grid">
        <div id="privacy-policy">
          <h2 id="privacy-heading" className="legal-heading">
            Privatësia
          </h2>
          <p className="legal-text">
            Përpunojmë të dhënat e kontaktit vetëm për t’iu përgjigjur pyetjeve dhe për të ofruar shërbimet tona. Nuk i shesim dhe nuk i ndajmë të dhënat tuaja me palë të treta. Mund të kërkoni qasje, korrigjim ose fshirje të të dhënave tuaja personale duke na kontaktuar në kontakt@techtalent-ks.com.
          </p>
        </div>
        <div id="terms">
          <h2 id="terms-heading" className="legal-heading">
            Kushtet e shërbimit
          </h2>
          <p className="legal-text">
            Shërbimet ofrohen sipas një marrëveshjeje me shkrim që përcakton qartë fushëveprimin, pronësinë intelektuale dhe detyrimet e të dyja palëve. Ky sajt është informues — kushtet e plota konfirmohen me shkrim para fillimit të çdo projekti.
          </p>
        </div>
      </div>
    </section>
  );
}

export default LegalSection;
